<template>
  <div
    id="feature-popup-mobile"
    v-if="
      (featurePopupAttributes && featurePopupAttributes.length) ||
        featurePopupHeader
    "
  >
    <b-row class="m-2 position-sticky">
      <b-col>
        <h6 v-if="true || featurePopupHeader" class="font-weight-bold">
          {{ featurePopupHeader }}
        </h6>
      </b-col>
      <b-col md="auto">
        <a
          href="#"
          id="feature-popup-close"
          class="float-right text-secondary"
          @click="closePopup"
        ></a>
      </b-col>
    </b-row>

    <div class="table-responsive">
      <table class="table table-bordered col-md-12">
        <tbody
          v-if="
            true || (featurePopupAttributes && featurePopupAttributes.length)
          "
        >
          <tr
            v-for="(attr, index) in featurePopupAttributes"
            :key="attr.key + '_' + index"
            v-if="keyIsNotIgnored(attr.key)"
          >
            <td>
              {{ attr.key }}
            </td>
            <td v-if="attr.isLink">
              <a :href="attr.val" target="_blank" rel="noopener noreferrer">{{
                attr.val
              }}</a>
            </td>
            <td v-else-if="attr.isFileList">
              <ul>
                <li v-for="item in attr.val" :key="item.path">
                  <a href="#" @click="downloadFile(item)">
                    {{ item.name }}
                  </a>
                </li>
              </ul>
            </td>
            <td v-else-if="dateKeysContains(attr.key)">
              {{ getFormattedDateString(attr.val) }}
            </td>
            <td v-else>
              <feature-popup-parsed-attr-value
                :attrVal="attr.val"
              ></feature-popup-parsed-attr-value>
            </td>
          </tr>
        </tbody>
        <tbody v-if="featurePopupHtml">
          <div v-html="featurePopupHtml"></div>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { SELECT_FEATURE_POPUP_HIDE } from '../store/mutations.type';
import { Api as ApiStawki } from '../api/api-stawki';
import SettingsInstance from '../api/SettingsInstance';
import FeaturePopupParsedAttrValue from './FeaturePopupParsedAttrValue';

const START_WIDTH = 500;
const START_HEIGHT = 400;

export default {
  name: 'FeaturePopupMobile',
  components: {
    FeaturePopupParsedAttrValue
  },
  data: function() {
    return {
      ignoredKeys: ['id'],
      // klucze dla dat - powiazane z taskiem #34484
      datesKeys: [
        'Z.2.II.6. Przewidywana data rozpoczęcia robót budowlanych.',
        'Z.2.III.6. Przewidywana data rozpoczęcia robót budowlanych.',
        'Z.2.IV.6. Przewidywana data rozpoczęcia robót budowlanych.'
      ]
    };
  },
  computed: {
    ...mapGetters([
      'featurePopupAttributes',
      'featurePopupHeader',
      'featurePopupHtml'
    ])
    // currentWidth() {
    //   return this.width + 'px';
    // },
    // currentHeight() {
    //   return this.height + 'px';
    // }
  },
  mounted() {
    // let self = this;
    // this.width = START_WIDTH;
    // this.height = START_HEIGHT;
    // self.$store.watch(
    //   () => self.$store.getters.featurePopupPosition,
    //   (value, oldValue) => {
    //     var el = document.getElementById(self.popupContentId);
    //     el.scrollTop = 0;
    //     this.width = START_WIDTH;
    //     this.height = START_HEIGHT;
    //   }
    // );
  },
  methods: {
    async downloadFile(item) {
      if (item.apiAction && item.apiAction == 'getStawkiZalacznikiByPath') {
        let baseUrl = SettingsInstance.baseApiUrl.trim('/');
        baseUrl += '/stawki_zalaczniki/' + item.path;
        window.location = baseUrl;
      }
    },
    keyIsNotIgnored(key) {
      return !this.ignoredKeys.includes(key);
    },
    closePopup() {
      this.$store.commit(SELECT_FEATURE_POPUP_HIDE);
    },

    dateKeysContains(key) {
      return this.datesKeys.indexOf(key) > -1;
    },
    getFormattedDateString(value) {
      return value.toString().substring(0, 10);
    }
  }
};
</script>
<style>
.table-responsive {
  height: 100%;
  width: fit-content;
  overflow: auto;
}
.table-responsive pre {
  text-wrap: wrap;
}
.feature-popup-preformatted {
}
</style>
